<template>
  <div v-if="content.length" :class="containerClasses">
    <template v-if="isPageContentArea">
      <div class="visual_menu--page_content">
        <div class="visual_menu--section" v-html="content"></div>
      </div>
    </template>
    <template v-else>
      <div v-html="content"></div>
    </template>
  </div>
</template>

<script lang="ts">
/**
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.1.0
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-03-23 (1.0.0) (jhoward)
 *      - <menu-content-area> handles displaying content above or below a section.
 *
 *  2025-04-08 (1.1.0) (jhoward)
 *    - Remove "visual_" prefix from class names in <menu-content-area>.
 */

import {defineComponent} from "vue";

export default defineComponent({
  name: "menu-content-area",
  props: {
    content: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'section',
      validate: (value) => ['section', 'page'].indexOf(value)
    },
    position: {
      type: String,
      default: 'top',
      validate: (value) => ['top', 'bottom'].indexOf(value)
    }
  },
  computed: {
    isPageContentArea(): boolean {
      return 'page' === this.type;
    },
    isSectionContentArea(): boolean {
      return 'section' === this.type;
    },
    isPositionTop(): boolean {
      return 'top' === this.position;
    },
    isPositionBottom(): boolean {
      return 'bottom' === this.position;
    },
    containerClasses(): {[key: string]: boolean} {
      return {
        //type=page
        'visual_menu--page': this.isPageContentArea ,
        'visual_menu--content_top': this.isPageContentArea && this.isPositionTop,
        'visual_menu--content_bottom': this.isPageContentArea && this.isPositionBottom,

        //type=section
        'visual_menu--page_section': this.isSectionContentArea,
        'visual_menu--page_section-top': this.isSectionContentArea && this.isPositionTop,
        'visual_menu--page_section-bottom': this.isSectionContentArea && this.isPositionBottom,
      };
    }
  }
})
</script>

<style scoped>
.visual_menu--page_content {
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
}

.menu--section_title .visual_menu--page_section-top {
  padding-bottom: 0;
}

.visual_menu--page_section-top,
.visual_menu--page_section-bottom {
  text-align: center;
  padding-bottom: 1.5em;
  /*margin-top: -1.2em;*/
}

.visual_menu--page_section-bottom {
  padding-top: 2em;
  text-align: center;
}

.menu--section_title .visual_menu--page_section >>> h3,
.menu--section_title .visual_menu--page_section >>> p {
  color: #3e2603;
}

@media (prefers-contrast: more) {
  .menu--section_title .visual_menu--page_section >>> h3,
  .menu--section_title .visual_menu--page_section >>> p {
    color: #000;
  }
}

.menu--section_title .visual_menu--page_section >>> p {
  line-height: 1.1em;
  font-weight: 300;
  font-size: 0.9em;
}
</style>